// Pilha (nível de módulo, compartilhada por todas as instâncias de
// Modal.vue) dos modais atualmente abertos. Com modais aninhados — ex:
// Detalhe de Venda aberto por cima do modal de Produto, ver
// openProductHistorySale em Vendas.vue — a tecla Esc deve fechar só o
// modal do topo, não todos os que estiverem abertos ao mesmo tempo.
export const openModalStack = []
